module.exports = __webpack_public_path__ + "static/media/splash.b838e0d8.jpg";